import { render, staticRenderFns } from "./ConflictDetail.vue?vue&type=template&id=9cb297e0&scoped=true"
import script from "./ConflictDetail.vue?vue&type=script&lang=js"
export * from "./ConflictDetail.vue?vue&type=script&lang=js"
import style0 from "./ConflictDetail.vue?vue&type=style&index=0&id=9cb297e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb297e0",
  null
  
)

export default component.exports